import React from 'react';
import styled from 'styled-components';
import { StatusFieldOption, TaskType } from 'api/tasks';
import { StatusIndicator } from 'components/molecules/status-indicator';
import { CpMenu } from '../modal/cp-menu';

export interface CpStatusPickerProps {
  options: StatusFieldOption[];
  onChange: (change: StatusFieldOption) => void;
  selectedOption?: number;
  title?: React.ReactNode;
  dontStopPropagation?: boolean;
  type?: TaskType;
}

const MenuHeader = styled.div`
  padding: var(--cp-spacing-05);
  padding-bottom: var(--cp-spacing-03);
  margin-bottom: 0;
  font-weight: var(--font-weight-bold);
`;

const StyledMenu = styled(CpMenu)`
  box-shadow: var(--shadow-08);
  border-radius: var(--border-radius-small);
  padding-top: 0 !important;
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  box-shadow: none !important;
  max-height: 27vh !important;

  .ant-menu {
    max-height: 27vh !important;
  }

  .ant-menu-item {
    padding-left: var(--cp-spacing-05);
    padding-right: var(--cp-spacing-05);
  }
`;

const Span = styled.span`
  margin-left: var(--cp-spacing-03);
`;

export const CpStatusPicker: React.FC<CpStatusPickerProps> = ({
  options,
  selectedOption,
  onChange,
  title,
  dontStopPropagation,
  type,
}) => {
  return (
    <>
      <MenuHeader>{title}</MenuHeader>
      <StyledMenu>
        {/* {title ? <CpMenu.Header>{title}</CpMenu.Header> : <></>} */}
        {options
          .filter((option) => option.active)
          .map((option) => {
            return (
              <CpMenu.Item
                data-cy={`cp.status-picker-${option.value}`}
                key={option.value}
                active={selectedOption === option?.value}
                onClick={(event) => {
                  if (!dontStopPropagation) {
                    event.domEvent.stopPropagation?.();
                  }
                  onChange(option);
                }}
              >
                <StatusIndicator
                  type={type}
                  status={option}
                  showTooltip={false}
                />
                <Span className="cp-ml-1">{option.label}</Span>
              </CpMenu.Item>
            );
          })}
      </StyledMenu>
    </>
  );
};
